import { CByteArray } from "./CByteArray";

export class CCountDown {
    private m_mcP:fgui.GComponent;
    private m_tF:fgui.GTextField;
    private m_RuleSecs:number;
    private m_Secs:number;
    private m_Show:number;
    private m_Auto:number;

    constructor(dc:fgui.GComponent, secs:number) {
        this.m_mcP = dc.getChild("mc_Countdown") as fgui.GComponent;
        this.m_tF = this.m_mcP.getChild("txt_CountDown") as fgui.GTextField;
        this.m_Show = 0;
        this.m_Auto = 0;
        this.m_RuleSecs = secs;
        this.m_Secs = this.m_RuleSecs;
    }

    // public update(secT:number, secN:number, anim:boolean = true):void {
    //     if( secN < 0 ) this.m_mcP.visible = false;
    //     else {
    //         if( this.m_mcP.visible == false ) this.m_mcP.visible = true;
    //         this.m_tF.text = ""+secN;
    //         if( anim )
    //             createjs.Tween.get(this.m_mcP, {override:true})
    //                 .to({scaleX:1.1, scaleY:1.25}, 100, createjs.Ease.quadIn)
    //                 .to({scaleX:1.0, scaleY:1.0}, 200, createjs.Ease.quadOut);
    //     }
    // }

    public Reset():void {
        this.m_mcP.visible = false;
    }

    public IsAuto():number { return this.m_Auto; }
	public GetStat():number { return this.m_Secs; }

    private onOneSeconds():void {
        this.m_Secs --;
        if( this.m_Secs > 0 ) {
            this.m_tF.text = ""+this.m_Secs;
            createjs.Tween.get(this.m_mcP, {override:true})
                    .to({scaleX:1.1, scaleY:1.25}, 100, createjs.Ease.quadIn)
                    .to({scaleX:1.0, scaleY:1.0}, 200, createjs.Ease.quadOut)
                    .wait(700)
                    .call(this.onOneSeconds.bind(this));
        }
    }

    public Show():void { 
        this.m_Secs = this.m_RuleSecs;
        if( this.m_mcP.visible == false ) this.m_mcP.visible = true;
        this.m_tF.text = ""+this.m_Secs;
        createjs.Tween.get(this.m_mcP, {override:true})
                    .to({scaleX:1.1, scaleY:1.25}, 100, createjs.Ease.quadIn)
                    .to({scaleX:1.0, scaleY:1.0}, 200, createjs.Ease.quadOut)
                    .wait(700)
                    .call(this.onOneSeconds.bind(this));
    }
}
